export default __webpack_public_path__ + "static/media/close-12.1a84b9c5.svg";